import { TFunction } from "i18next";
import { I18nError } from "./I18nError";

export class UnexpectedError extends I18nError {
  i18nMessage(t: TFunction): string {
    return t("error.unexpected");
  }
}
